import { BackLink } from '~/entities/BackLink/BackLink';
import { Badge } from '~/entities/Badge/Badge';
import { PageWrapper } from '~/shared/ui/PageWrapper/PageWrapper';
import { ProfileItemsList } from '~/pages/ProfilePage/ui/ProfileItemsList/ProfileItemsList';
import { Wrapper } from '~/shared/ui/Wrapper/Wrapper';
import { useUserStore } from '~/shared/store/userStore';
import { useMainPageStore } from '~/pages/MainPage/model/useMainPageStore';
import { useGetCards } from '~/shared/hooks/useGetCards';
import { useGetCars } from '~/shared/hooks/useGetCars';
import { useEffect } from 'react';
import { useGetPastRents } from '~/shared/hooks/useGetPastRents';

export const ProfilePage = ({
  toMainPage = true,
  onClose,
}: {
  toMainPage?: boolean;
  onClose?: () => void;
}) => {
  const { state } = useUserStore();
  const { actions } = useMainPageStore();

  const { setIsOpen } = actions;

  const { refetch: refetchCars } = useGetCars();
  const { refetch: refetchCards } = useGetCards();
  const { refetch: refetchRents } = useGetPastRents('in_progress', false);
  const { refetch: refetchPastRents } = useGetPastRents('completed', false);

  useEffect(() => {
    refetchCards();
    refetchCars();
    refetchRents();
    refetchPastRents();
  }, []);

  return (
    <PageWrapper>
      <BackLink
        href={toMainPage ? '/' : undefined}
        text={'Профиль'}
        navigation={false}
        onClick={() => {
          setIsOpen('none');
          onClose?.();
        }}
      />
      <Wrapper>
        <Badge name={state.fio} phone={state.phone} />
        <ProfileItemsList />
      </Wrapper>
    </PageWrapper>
  );
};
